@import '../../../../style/src/typography/mixins';

::slotted(*) {
	@include zds-typography('caption-sm');

	display: block;
	font-weight: 500;
}

.zds-tooltip {
	--zds-popout-background: var(--zds-color-grey-50);
	--zds-popout-border-color: transparent;
	--zds-popout-border-radius: var(--zds-shape-radius-sm);
	--zds-popout-inset: var(--zds-space-1_5) var(--zds-space-2);

	color: var(--zds-color-grey-50-foreground);

	&--dark {
		--zds-popout-background: var(--zds-color-grey-700);

		color: var(--zds-color-grey-700-foreground);
	}

	&__content {
		@include zds-typography('caption-sm');

		font-weight: 500;
	}
}

@keyframes grow-in {
	from {
		opacity: 0;
		transform: scale(0);
	}

	to {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes grow-out {
	from {
		opacity: 1;
		transform: scale(1);
	}

	to {
		opacity: 0;
		transform: scale(0);
	}
}
